const dashboard = () => import('../views/report/dashboard.vue')
const projectList = () => import('../views/report/projects/going.vue')
const projectNew = () => import('../views/report/projects/new.vue')
const projectEdit = () => import('../views/report/projects/edit.vue')
const projectDetail = () => import('../views/report/projects/show.vue')

const projectArchiveList = () => import('../views/report/projects/archive.vue')

const regionList = () => import('../views/report/regions/index.vue')
const regionNew = () => import('../views/report/regions/new.vue')
const regionEdit = () => import('../views/report/regions/edit.vue')


const drillTripList = () => import('../views/report/drill_trips/index.vue')
const drillTripDetail = () => import('../views/report/drill_trips/show.vue')

const reportList = () => import('../views/report/reports/index.vue')
const reportNew = () => import('../views/report/reports/new.vue')
const reportEdit = () => import('../views/report/reports/edit.vue')
const reportDetail = () => import('../views/report/reports/show.vue')

const userList = () => import('../views/report/users/index.vue')
const userEdit = () => import('../views/report/users/edit.vue')

const drillList = () => import('../views/report/drills/index.vue')
const drillNew = () => import('../views/report/drills/new.vue')
const drillDetail = () => import('../views/report/drills/show.vue')

export default [
    {
        path: "/report/drills", component: drillList, meta: {
            module_name: 'report',
            en_name: "reportDrill",
            auth_id: 22100
        }
    },
    {
        path: "/report/drills/new", component: drillNew, meta: {
            module_name: 'report',
            en_name: "reportDrill",
            auth_id: 22101
        }
    },
    {
        path: "/report/drills/:id", component: drillDetail, meta: {
            module_name: 'report',
            en_name: "reportDrill",
            auth_id: 22103
        }
    },
    {
        path: "/report/users", component: userList, meta: {
            module_name: 'report',
            en_name: "reportUser",
            auth_id: 26100
        }
    },
    {
        path: "/report/users/:id/edit", component: userEdit, meta: {
            module_name: 'report',
            en_name: "reportUser",
            auth_id: 26101
        }
    },
    {
        path: "/report/reports", component: reportList, meta: {
            module_name: 'report',
            en_name: "reportReport",
            auth_id: 24100
        }
    },
    {
        path: "/report/reports/new", component: reportNew, meta: {
            module_name: 'report',
            en_name: "reportReport",
            auth_id: 24101
        }
    },
    {
        path: "/report/reports/:id/edit", component: reportNew, meta: {
            module_name: 'report',
            en_name: "reportReport",
            auth_id: 24103
        }
    },
    {
        path: "/report/reports/:id", component: reportDetail, meta: {
            module_name: 'report',
            en_name: "reportReport",
            auth_id: 24102
        }
    },
    {
        path: '/report/dashboard',
        component: dashboard,
        name: 'moduleDashboard',
        meta: {
            module_name: 'report',
        }
    },
    {
        path: '/report/projects',
        component: projectList,
        meta: {
            module_name: 'report',
            en_name: 'reportProject',
            auth_id: 21100
        }
    },

    {
        path: '/report/projects/new',
        component: projectNew,
        meta: {
            module_name: 'report',
            en_name: 'reportProject',
            auth_id: 21101
        }
    },
    {
        path: '/report/projects/:id/edit',
        component: projectNew,
        meta: {
            module_name: 'report',
            en_name: 'reportProject',
            auth_id: 21103
        }
    },
    {
        path: '/report/projects/:id',
        component: projectDetail,
        meta: {
            module_name: 'report',
            en_name: 'reportProject',
            auth_id: 21102
        }
    },
    {
        path: '/report/archive_projects',
        component: projectArchiveList,
        meta: {
            module_name: 'report',
            en_name: 'reportArchiveProject',
            auth_id: 21100
        }
    },
    {
        path: '/report/archive_projects/:id',
        component: projectDetail,
        meta: {
            module_name: 'report',
            en_name: 'reportArchiveProject',
            auth_id: 21102
        }
    },
    {
        path: '/report/regions',
        component: regionList,
        meta: {
            module_name: 'report',
            en_name: 'reportRegion',
            auth_id: 29100
        }
    },
    {
        path: '/report/regions/new',
        component: regionNew,
        meta: {
            module_name: 'report',
            en_name: 'reportRegion',
            auth_id: 29101
        }
    },
    {
        path: '/report/regions/:id/edit',
        component: regionEdit,
        meta: {
            module_name: 'report',
            en_name: 'reportRegion',
            auth_id: 29102
        }
    },
    {
        path: '/report/drill_trips',
        component: drillTripList,
        meta: {
            module_name: 'report',
            en_name: 'reportDrillTrip',
            auth_id: 23100
        }
    },
    {
        path: '/report/drill_trips/:id',
        component: drillTripDetail,
        meta: {
            module_name: 'report',
            en_name: 'reportDrillTrip',
            auth_id: 23102
        }
    },
]
